import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLocation: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"location, explore, compass"} maskId="square-filled-radius-0-stroke-1-IconLocation"><path fillRule="evenodd" clipRule="evenodd" d="M6.597 6.59553L21.7295 2.27197L17.4059 17.4044L2.27344 21.728L6.597 6.59553ZM9.25143 12C9.25143 10.4812 10.4827 9.25 12.0014 9.25C13.5202 9.25 14.7514 10.4812 14.7514 12C14.7514 13.5188 13.5202 14.75 12.0014 14.75C10.4827 14.75 9.25143 13.5188 9.25143 12Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconLocation;
